import styled from 'styled-components';
import { P, fs, radius, shadow, ease, onPhone, scrollRow } from '../theme/tokens';

const Bar = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${(p) => (p.$bare ? 6 : 4)}px;
  padding: ${(p) => (p.$bare ? 0 : 4)}px;
  background: ${(p) => (p.$bare ? 'transparent' : P.white)};
  border: ${(p) => (p.$bare ? 'none' : `1px solid ${P.line}`)};
  border-radius: ${radius.xl}px;
  box-shadow: ${(p) => (p.$bare ? 'none' : shadow.sm)};
  ${onPhone} {
    display: flex;
    flex-wrap: nowrap;
    max-width: 100%;
    ${scrollRow}
  }
`;

const Chip = styled.button`
  border: none;
  padding: 7px 18px;
  border-radius: ${radius.pill}px;
  font-family: inherit;
  font-size: ${fs.sm}px;
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  color: ${(p) => (p.$active ? P.white : P.muted)};
  background: ${(p) => (p.$active ? P.grad : 'transparent')};
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 150ms ${ease}, color 150ms ${ease};
  ${onPhone} {
    flex: none;
  }

  &:hover {
    color: ${(p) => (p.$active ? P.white : P.ink)};
    background: ${(p) => (p.$active ? P.grad : P.gray200)};
  }
  &:focus-visible {
    outline: 2px solid ${P.navy};
    outline-offset: 2px;
  }
`;

export default function FilterChips({ options, value, onChange, label, bare }) {
  return (
    <Bar role="group" aria-label={label} $bare={bare}>
      {options.map((o) => (
        <Chip
          key={o.key}
          type="button"
          $active={o.key === value}
          aria-pressed={o.key === value}
          onClick={() => onChange(o.key)}
        >
          {o.icon}
          {o.label}
        </Chip>
      ))}
    </Bar>
  );
}
